// import "./portfolio.css";
import * as React from "react";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {useState} from "react";
import {useEffect} from "react";
import {Grid} from "@mui/material";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {BottomNavigation} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {getTotalunit} from "../../../../apihelper/cryptocurrencylist.js";
import {getPerformanceSummaryShare} from "../../../../apihelper/portfolio.js";
import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router-dom";
import GoToSubscribeAlert from "../../../../common/alert/GoToSubscribeAlert.jsx";
import {PORTFOLIO_ANALYSIS_MESSAGE} from "../../../../common/constant/SubscriptionMessage.jsx";
import {getUserAccessPermission, getUserTotalView} from "../../../../apihelper/profile.js";
import {PERFORMANCE_SUMMARY_FEATURE} from "../../../../common/constant/SubscriptionFeatures.jsx";

const useStyles = styled((theme) => ({
    tableContainer: {
        maxWidth: 600,
        margin: "0 auto",
    },
    table: {
        display: "none", // Hide the table on all screens
        [theme.breakpoints.down("sm")]: {
            display: "table", // Show the table on small screens only (mobile view)
        },
    },
    cardContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            display: "none", // Hide the card container on small screens (mobile view)
        },
    },
    card: {
        width: "100%",
        margin: "8px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "300px", // Adjust the card width as needed
        },
    },
}));

// Define the keyframes for the left-right motion animation
const leftRightMotion = `
  @keyframes leftRightMotion {
    0% {
      transform: translateX(-30px); /* Start 30px left of center */
    }
    50% {
      transform: translateX(30px);  /* Move 30px right of center */
    }
    100% {
      transform: translateX(-30px); /* Return to 30px left of center */
    }
  }
`;

const drawerWidth = 2;

const cellStyle = {
    textAlign: "center",
    color: "rgba(0, 0, 0, 1)",
    fontSize: "11px",
    width: "100%",
    height: "60px", // Fixed height
    fontWeight: "700",
    background: "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
    padding: "12px 2spx",
    margin: "0px 0px 10px 2px",
    borderBottom: "5px solid rgba(24, 119, 242, 1)",
    borderRight: "1px solid rgba(24, 119, 242, 1)",
    borderLeft: "0px solid #FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
function PerformanceTable(props = {}) {
    const {selectedPortfolio} = props;
    const [portfolioName, setPortfolioName] = useState(selectedPortfolio);
    const mPortfolioName = selectedPortfolio;

    const [isLoginModalOpen, setLoginModalOpen] = useState(false);

    React.useEffect(() => {
        setPortfolioName(selectedPortfolio);
    }, [selectedPortfolio]);

    const handleLoginClick = () => {
        if (!userData) {
            window.history.pushState({}, "", "/login");
            localStorage.setItem("isPopupManuallyOpened", "true");
            setLoginModalOpen(true);
        } else if (!isEligible) {
            setGoToSubscribeAlertOpen(true);
            setSubscriptionText(PORTFOLIO_ANALYSIS_MESSAGE);
        }
    };

    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 420,
        })
    );

    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [newOptionValue, setNewOptionValue] = useState("");
    const [dataslug, setdataslug] = useState("");

    const handleClose = () => setOpen(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [selectedOption, setSelectedOption] = useState([]);
    const [alignment, setAlignment] = React.useState("left");
    const [loader, setLoader] = useState(false);
    const [slugdata, setSlugdata] = useState([]);
    const [slugdataP, setSlugdataP] = useState([]);

    const [category, setCategory] = useState([]);
    const [index, setIndex] = useState(0);
    const [portfolioId, setportfolioid] = useState("");
    const [totalUnits, setTotalUnits] = useState(0);
    const [Usablewallet, setUsablewallet] = useState("");
    const [portfolioTypeId, setPortfolioTypeId] = useState("");

    const [user_role, setuser_role] = useState("");
    const [addMoreLoader, setAddMoreLoader] = useState(false);
    const [filter, setFilter] = useState("");
    const [profilename, setprofilename] = useState("...");
    const [loaderbutton, setLoaderButton] = useState(true);
    const [roivalue, setRoivalue] = useState("-");
    const [portfoliovalue, setPortfoliovalue] = useState("-");
    const [lastUpdatedTime, setLastUpdatedTiem] = useState("");
    const [slugpopupdata, setSlugpopupdata] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [msgAfterLoading, setMsgAfterLoading] = useState("");
    const [unit, setUnit] = useState("");
    const [buySell, setbuySell] = React.useState("");
    const [price, setPrice] = useState("");

    const [selectedDate, handleDateChange] = useState("");
    const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] = useState("loading...");
    const [severity, setSeverity] = useState("info");
    const [slugdataNew, setSlugdataNew] = useState([]);
    const [slugpopupdataNew, setSlugpopupdataNew] = useState({
        slugname: "",
        slug: "",
        units: 0,
    });
    const [initialPage, setInitialPage] = useState(false);
    const [localUserData, setLocalUserData] = useState(undefined);
    const [loaderForSymbolLink, setLoaderForSymbolLink] = useState(false);
    const [PortfolioRoivalue, setPortfolioRoivalue] = useState("-");
    const [nodatafoundmsgtype, setnodatafoundmsgtype] = useState("");
    const [currentwallet, setcurrentwallet] = useState("-");
    const [sharpratio, setSharpRatio] = useState("--");
    const [portfolio_1day, setPortfolio_1day] = useState("");
    const [portfolio_7days, setPortfolio_7days] = useState("");
    const [portfolio_30days, setPortfolio_30days] = useState("");
    const [portfolio_90days, setPortfolio_90days] = useState("");
    const [portfolio_grade, setportfolio_grade] = useState("");

    const location = useLocation();
    const loc = location.pathname;
    const [sortedData, setSortedData] = useState([]);
    const [rating, setRating] = useState("");

    const [goToSubscribeAlertOpen, setGoToSubscribeAlertOpen] = useState(false);
    const [subscriptionText, setSubscriptionText] = useState("");
    const [isEligible, setIsEligible] = useState(true);
    const [userPermission, setUserPermission] = useState(null);
    const [userViews, setUserViews] = useState(0);

    const handleTotalViews = async () => {
        try {
            const userInfo = {
                user_id: userData.user_id,
                token: userData.token,
                column: "portfolio_analysis",
            };
            const response = await getUserTotalView(userInfo);
            setUserViews(response.permission);
        } catch (error) {
            console.error(error);
        }
    };
    const handleUserPermission = React.useCallback(async () => {
        try {
            const feature = PERFORMANCE_SUMMARY_FEATURE();
            const data = {
                user_id: userData.user_id,
                token: userData.token,
                feature: feature,
            };
            const response = await getUserAccessPermission(data);
            setUserPermission(response?.permission);
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        handleTotalViews();
        handleUserPermission();
    }, []);

    const handleChange2 = (e) => {
        const value = e.target.value;
        // Check if the input contains a hyphen
        if (value.includes("-")) {
            setShowAlert(true); // Show the alert if there's a hyphen
        } else {
            setShowAlert(false); // Hide the alert if there's no hyphen
            setNewOptionValue(value); // Update the state with the new value
        }
    };

    const handleDialogSubmit = () => {
        const newOption = {value: newOptionValue, label: newOptionValue};
        setOptions((prevOptions) => [...prevOptions, newOption]);
        setSelectedOption(newOption);
        setIsDialogOpen(false);

        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        getTotalunit({
            user_id: userData.user_id,
            slug: dataslug,
            portfolio_type_id: newOption.value,
            Token: userData.token,
        }).then((response) => {
            if (response.code === "200") {
                setTotalUnits(response.total_uint);
                setNewOptionValue("");
                setUsablewallet(response.wallet_amount);
            } else {
                console.error("Data fetching error");
            }
        });
    };

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const isSmallScreen = useMediaQuery(
        json2mq({
            maxWidth: 1300,
        })
    );
    var rows = [],
        i = 0,
        len = 15;
    while (++i <= len) rows.push(i);
    const handleCreateNew = () => {
        // router.push(`/${path}`);
        navigate("/cryptocurrencylist", {replace: true});
    };

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        setLocalUserData(userData);
        const user_idValue = userData ? userData.user_id : 0;
        const user_token = userData ? userData.token : 0;

        if (!portfolioName) {
            return;
        }
        getPerformanceSummaryShare({
            slug: filter,
            user_id: user_idValue,
            portfolio_id: portfolioName,
            start_index: `${index}`,
            limit: `${10}`,
            Token: user_token,
        }).then((res) => {
            if (res.code === "200") {
                setRoivalue(res.total_profit);
                setPortfoliovalue(res.total_portfolio_value);
                setPortfolioRoivalue(res.roi_average);
                setSlugdata(res.data);
                setnodatafoundmsgtype(res.no_data_found_msgtype);
                setcurrentwallet(res.current_wallet);
                setLastUpdatedTiem(res.updated_on);
                setprofilename(res.portfolio_name);
                setSharpRatio(res.sharpeRatio);
                setportfolioid(res.portfolio_Id);
                setPortfolio_1day(res.portfolio_1day);
                setPortfolio_7days(res.portfolio_7days);
                setPortfolio_30days(res.portfolio_30days);
                setPortfolio_90days(res.portfolio_90days);
                setportfolio_grade(res.portfolio_grade);
                setRating(res.rating);
                setInitialPage(false);
                if (res.data.length === 0) {
                    setInitialPage(true);
                }
                if (res.data.length < 10) {
                    setLoaderButton(false);
                } else {
                    setLoaderButton(true);
                }
                setLoader(true);
                setAddMoreLoader(false);
            } else {
                console.error("Data fething error");
            }
        });
    }, [portfolioName]);

    const closesnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackbaropen(false);
    };

    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            border: 0,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            border: 0,
        },
    }));

    const StyledTableRow = styled(TableRow)(({theme}) => ({
        // hide last border

        "& td, & th": {
            border: 0,
        },
    }));

    useEffect(() => {
        if (slugdata) {
            const sortedData = slugdata.sort((a, b) => {
                const order = {
                    Outperformer: 1,
                    "Emerging Outperformer": 2,
                    "Moderate Performer": 3,
                    Underperformer: 4,
                };

                // First sort by buy_percent
                const buyPercentComparison = order[a.buy_percent] - order[b.buy_percent];

                if (buyPercentComparison !== 0) {
                    return buyPercentComparison;
                }

                // If buy_percent is the same, sort by average performance
                return b.avg_change - a.avg_change;
            });

            // Update the state with the sorted data
            setSortedData(sortedData);
            const sortedDataSlugs = sortedData.map((item) => item.slug);
            const sortedSlugdataNew = slugdataNew.slice().sort((a, b) => {
                return sortedDataSlugs.indexOf(a.slug) - sortedDataSlugs.indexOf(b.slug);
            });

            setSlugdataNew(sortedSlugdataNew);
        }
    }, [slugdata]);

    const url = `/portfolio/${portfolioName}/recommendations`;

    return (
        <>
            {mediaQueryVar === true ? (
                <Box
                    sx={{
                        flexDirection: mediaQueryVar === false ? "column" : "",

                        display: "flex",
                    }}
                    className="maindiv"
                >
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                        }}
                    >
                        {initialPage && (
                            <Box
                                component="main"
                                sx={{
                                    flexGrow: 1,
                                }}
                            >
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        marginTop: "0px",
                                        marginBottom: "9px",
                                        marginLeft: mediaQueryVar === false ? "-5px" : "",
                                    }}
                                ></Grid>
                                <div style={{borderRadius: "10px", background: "white", padding: "10px"}}>
                                    <div className="frameParent8">
                                        <div className="frameParent9" style={{padding: "10px"}}>
                                            <img
                                                className="frameIcon6"
                                                alt=""
                                                src={window.constants.asset_path + "/images/frame20.svg"}
                                            />
                                            <div className="youDontHaveContainer">
                                                {nodatafoundmsgtype === "zeroholding" ? (
                                                    <strong>
                                                        <h3
                                                            className="youDontHave"
                                                            style={{fontWeight: "400", color: "black"}}
                                                        >
                                                            You have 0 Holdings at the Moment
                                                        </h3>
                                                        {/* <h3 style={{ fontWeight: "400", color: "black" }}>0 Holdings at the Moment </h3> */}
                                                    </strong>
                                                ) : (
                                                    <strong>
                                                        <h3
                                                            className="youDontHave"
                                                            style={{fontWeight: "400", color: "black"}}
                                                        >
                                                            Create New
                                                        </h3>
                                                        <h3 style={{fontWeight: "400", color: "black"}}>Portfolio </h3>
                                                    </strong>
                                                )}
                                                <button
                                                    style={{
                                                        backgroundColor: "#4460EF",
                                                        width: "200px",
                                                        height: "50px",
                                                        borderRadius: "5px",
                                                        marginTop: "20px",
                                                        border: "2px solid #4460EF",
                                                        color: "white",
                                                    }}
                                                    onClick={handleCreateNew}
                                                >
                                                    Add Cryptos to this Portfolio
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        )}
                        {!initialPage && (
                            <>
                                <div
                                    style={{
                                        border: "1px solid white",
                                        borderRadius: "8px",
                                        margin: isSmallScreen ? "0px 15px 10px 10px" : "0px 25px 10px 10px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0)",
                                        backgroundColor: "white",
                                    }}
                                >
                                    <TableContainer
                                        style={{
                                            minHeight: loader ? "" : "130px",
                                            backgroundImage: loader ? "none" : "none",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center center",
                                            overflowX: "hidden",
                                            border: "1px solid #DADEDF",
                                            borderRadius: "5px",
                                            padding: 0,
                                            position: "relative",
                                        }}
                                    >
                                        {!loader && (
                                            <>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        borderRadius: "8px",
                                                        textAlign: "center",
                                                        zIndex: 999,
                                                        backdropFilter: "none", // Ensures the content isn't affected by the parent's blur
                                                        padding: "20px", // Optional: to add some spacing inside the div
                                                    }}
                                                >
                                                    <style>{leftRightMotion}</style>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            display: "inline-block",
                                                            width: "40px",
                                                            height: "40px",
                                                        }}
                                                    >
                                                        {!isEligible && !loader ? (
                                                            <img
                                                                onClick={(e) => {
                                                                    if (!userData || !isEligible) {
                                                                        e.preventDefault(); // Prevent navigation

                                                                        const originalUrl = `${
                                                                            process.env.REACT_APP_HOME_URL
                                                                        }portfolio/${portfolioName.replace(
                                                                            /\s+/g,
                                                                            "-"
                                                                        )}`; // Use backticks for template literals
                                                                        sessionStorage.setItem(
                                                                            "originalUrl",
                                                                            originalUrl
                                                                        ); // Save the original URL to sessionStorage

                                                                        handleLoginClick(); // Trigger the login click handler
                                                                    }
                                                                }}
                                                                src={window.constants.asset_path + "/images/lock.svg"}
                                                                alt="Lock Icon"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    left: "40%",
                                                                    transform: "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                    width: "20px", // Adjust size as needed
                                                                    height: "20px",
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={window.constants.asset_path + "/images/lens.png"}
                                                                alt="Searching Lens"
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    position: "absolute",
                                                                    animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <p style={{marginTop: "10px", fontSize: "18px", color: "black"}}>
                                                        {!userData ? (
                                                            <b>Sign Up now to Access Portfolio Analysis</b>
                                                        ) : !isEligible && !loader ? (
                                                            <b>{PORTFOLIO_ANALYSIS_MESSAGE()}</b>
                                                        ) : (
                                                            <b>Analyzing Your Portfolio</b>
                                                        )}
                                                    </p>
                                                </div>
                                            </>
                                        )}
                                        {loader && (
                                            <Table
                                                className="non_responsiveTable"
                                                aria-label="customized table"
                                                style={{borderCollapse: "collapse"}}
                                            >
                                                <TableHead style={{padding: 0, margin: 0}}>
                                                    <TableRow>
                                                        <StyledTableCell
                                                            component="th"
                                                            scope="row"
                                                            rowSpan={2}
                                                            style={{
                                                                borderBottom: "none",
                                                                color: "rgba(0, 0, 0, 1)",
                                                                fontFamily: "",
                                                                fontSize: "22px",
                                                                fontStyle: "normal",
                                                                fontWeight: "700",
                                                                lineHeight: "20px",
                                                                paddingLeft: "10px",
                                                                paddingTop: "12px",
                                                                paddingBottom: "14px",
                                                                borderRight: "1px solid #DADEDF",
                                                                width: "150px",
                                                                textAlign: "center",
                                                                filter: "none",
                                                                background:
                                                                    "linear-gradient(180deg, #1877F2 -1.89%, rgba(255, 255, 255, 0) 60.38%)",
                                                                border: "1px solid rgba(24, 119, 242, 1)",
                                                            }}
                                                        >
                                                            {mPortfolioName}
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            className="cryptotableviewHeader"
                                                            style={{padding: 0, width: "12%"}}
                                                        >
                                                            <button
                                                                disabled
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: "rgba(0, 0, 0, 1)",
                                                                    fontSize: mediaQueryVar === false ? "11px" : "16px",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    fontWeight: "700",
                                                                    border: "none",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    padding: isSmallScreen ? "12px 5px" : "12px 12px",
                                                                    margin: "0px 0px 10px 2px",
                                                                    borderBottom: "5px solid rgba(24, 119, 242, 1)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderLeft: "2px solid #FFF",
                                                                }}
                                                            >
                                                                Last 1 Day
                                                            </button>
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            className="cryptotableviewHeader"
                                                            style={{
                                                                padding: 0,
                                                                width: "12%",
                                                                bottomBorder: "5px solid",
                                                            }}
                                                        >
                                                            <button
                                                                disabled
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: "rgba(0, 0, 0, 1)",
                                                                    fontSize: mediaQueryVar === false ? "11px" : "16px",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    fontWeight: "700",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    padding: isSmallScreen ? "12px 5px" : "12px 12px",
                                                                    margin: "0px 0px 10px 2px",
                                                                    borderBottom: "5px solid rgba(24, 119, 242, 1)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderLeft: "2px solid #FFF",
                                                                }}
                                                            >
                                                                Last 7 Days
                                                            </button>
                                                        </StyledTableCell>

                                                        <StyledTableCell
                                                            className="cryptotableviewHeader"
                                                            style={{padding: 0, width: "12%"}}
                                                        >
                                                            <button
                                                                disabled
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: "rgba(0, 0, 0, 1)",
                                                                    fontSize: mediaQueryVar === false ? "11px" : "16px",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    fontWeight: "700",
                                                                    border: "none",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    padding: isSmallScreen ? "12px 5px" : "12px 12px",
                                                                    margin: "0px 0px 10px 2px",
                                                                    borderBottom: "5px solid rgba(24, 119, 242, 1)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderLeft: "2px solid #FFF",
                                                                }}
                                                            >
                                                                Last 30 Days
                                                            </button>
                                                        </StyledTableCell>

                                                        <StyledTableCell
                                                            className="cryptotableviewHeader"
                                                            style={{padding: 0, width: "12%"}}
                                                        >
                                                            <button
                                                                disabled
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: "rgba(0, 0, 0, 1)",
                                                                    fontSize: mediaQueryVar === false ? "11px" : "16px",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    fontWeight: "700",
                                                                    border: "none",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    padding: isSmallScreen ? "12px 5px" : "12px 12px",
                                                                    margin: "0px 0px 10px 2px",
                                                                    borderBottom: "5px solid rgba(24, 119, 242, 1)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderLeft: "2px solid #FFF",
                                                                }}
                                                            >
                                                                Last 90 Days
                                                            </button>
                                                        </StyledTableCell>

                                                        <StyledTableCell
                                                            className="cryptotableviewHeader"
                                                            style={{padding: 0, width: "15%"}}
                                                        >
                                                            <button
                                                                disabled
                                                                style={{
                                                                    textAlign: "center",
                                                                    color: "rgba(0, 0, 0, 1)",
                                                                    fontSize: mediaQueryVar === false ? "11px" : "16px",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    fontWeight: "700",
                                                                    border: "none",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    padding: isSmallScreen ? "12px 5px" : "12px 12px",
                                                                    margin: "0px 0px 10px 2px",
                                                                    borderBottom: "5px solid rgba(24, 119, 242, 1)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderLeft: "2px solid #FFF",
                                                                }}
                                                            >
                                                                Grade
                                                            </button>
                                                        </StyledTableCell>
                                                    </TableRow>
                                                    <StyledTableRow
                                                        style={{backgroundColor: "white", padding: 0, margin: 0}}
                                                    >
                                                        <StyledTableCell sx={{padding: 0}}>
                                                            <p
                                                                className="one"
                                                                style={{
                                                                    borderBottom: "none",
                                                                    margin: 0,
                                                                    color: "#000",
                                                                    fontFamily: "",
                                                                    fontSize: "15px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: "500",
                                                                    lineHeight: "38px",
                                                                    paddingTop: "12px",
                                                                    paddingBottom: "14px",
                                                                    borderRight: "1px solid #DADEDF",
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderBottom: "1px solid  rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                {portfolio_1day}
                                                            </p>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <p
                                                                className="one"
                                                                style={{
                                                                    borderBottom: "none",
                                                                    margin: 0,
                                                                    color: "#000",
                                                                    fontFamily: "",
                                                                    fontSize: "15px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: "500",
                                                                    lineHeight: "38px",
                                                                    paddingTop: "12px",
                                                                    paddingBottom: "14px",
                                                                    borderRight: "1px solid #DADEDF",
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderBottom: "1px solid  rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                {portfolio_7days}
                                                            </p>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <p
                                                                className="one"
                                                                style={{
                                                                    margin: 0,
                                                                    borderBottom: "none",
                                                                    color: "#000",
                                                                    fontFamily: "",
                                                                    fontSize: "15px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: "500",
                                                                    lineHeight: "38px",
                                                                    paddingTop: "12px",
                                                                    paddingBottom: "14px",
                                                                    borderRight: "1px solid #DADEDF",
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderBottom: "1px solid  rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                {portfolio_30days}
                                                            </p>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <p
                                                                className="one"
                                                                style={{
                                                                    borderBottom: "none",
                                                                    margin: 0,
                                                                    color: "#000",
                                                                    fontFamily: "",
                                                                    fontSize: "15px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: "500",
                                                                    lineHeight: "38px",
                                                                    paddingTop: "12px",
                                                                    paddingBottom: "14px",
                                                                    borderRight: "1px solid #DADEDF",
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderBottom: "1px solid  rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                {portfolio_90days}
                                                            </p>
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            <p
                                                                className="one"
                                                                style={{
                                                                    borderBottom: "none",
                                                                    margin: 0,
                                                                    color: "#000",
                                                                    fontFamily: "",
                                                                    fontSize: "15px",
                                                                    fontStyle: "normal",
                                                                    fontWeight: "500",
                                                                    lineHeight: "27px",
                                                                    paddingTop: "12px",
                                                                    paddingBottom: "14px",
                                                                    borderRight: "1px solid #DADEDF",
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    background:
                                                                        "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                                    borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                                    borderBottom: "1px solid  rgba(24, 119, 242, 1)",
                                                                }}
                                                            >
                                                                <div>
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {portfolio_grade === "Outperformer" ? (
                                                                            <button
                                                                                disabled
                                                                                style={{
                                                                                    alignItems: "center",
                                                                                    fontWeight: "bold",
                                                                                    padding: isSmallScreen
                                                                                        ? "3px "
                                                                                        : "3px",
                                                                                    borderRadius: "5px",
                                                                                    backgroundColor: "#DFFFF0",
                                                                                    color: "#199F5F",
                                                                                    border: "2px solid #199F5F",
                                                                                    width: "90%",
                                                                                }}
                                                                            >
                                                                                Outperformer
                                                                            </button>
                                                                        ) : portfolio_grade ===
                                                                          "Emerging Outperformer" ? (
                                                                            <button
                                                                                disabled
                                                                                style={{
                                                                                    fontWeight: "bold",
                                                                                    padding: isSmallScreen
                                                                                        ? "3px"
                                                                                        : "3px",
                                                                                    borderRadius: "5px",
                                                                                    backgroundColor: "#DFFFF0",
                                                                                    color: "#199F5F",
                                                                                    border: "2px solid #199F5F",
                                                                                    width: "90%",
                                                                                    fontSize: isSmallScreen
                                                                                        ? "10px"
                                                                                        : "10px",
                                                                                }}
                                                                            >
                                                                                Outperformer
                                                                            </button>
                                                                        ) : portfolio_grade === "Moderate Performer" ? (
                                                                            <button
                                                                                disabled
                                                                                style={{
                                                                                    fontWeight: "bold",
                                                                                    padding: isSmallScreen
                                                                                        ? "3px"
                                                                                        : "3px",
                                                                                    borderRadius: "5px",
                                                                                    backgroundColor: "#F9F4E7",
                                                                                    color: "#D4AF37",
                                                                                    border: "2px solid #D4AF37",
                                                                                    width: "90%",
                                                                                    fontSize: isSmallScreen
                                                                                        ? "10px"
                                                                                        : "10px",
                                                                                }}
                                                                            >
                                                                                Moderate Performer
                                                                            </button>
                                                                        ) : portfolio_grade === "Underperformer" ? (
                                                                            <button
                                                                                disabled
                                                                                style={{
                                                                                    alignItems: "center",
                                                                                    fontWeight: "bold",
                                                                                    padding: isSmallScreen
                                                                                        ? "3px "
                                                                                        : "3px",
                                                                                    borderRadius: "5px",
                                                                                    backgroundColor: "#FFE3E3",
                                                                                    color: "#FF4141",
                                                                                    border: "2px solid #FF4141",
                                                                                    width: "90%",
                                                                                }}
                                                                            >
                                                                                Underperformer
                                                                            </button>
                                                                        ) : (
                                                                            <span style={{fontSize: "15px"}}>NA</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </p>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </TableHead>
                                            </Table>
                                        )}
                                        {slugdata.length === 0 && loader === true && (
                                            <div style={{textAlign: "center", marginTop: "20px"}}>
                                                <h4>No Data Found</h4>
                                            </div>
                                        )}
                                    </TableContainer>
                                </div>
                                {/* <Typography
                                    variant="outlined"
                                    style={{
                                        color: "#1877F2",

                                        textTransform: "none",
                                        fontFamily: "Satoshi, sans-serif",
                                        fontWeight: "700",
                                        fontSize: "18px",
                                        padding: "5px 20px",

                                        marginLeft: "-15px",
                                        marginTop: "4%",
                                        marginBottom: "10%",
                                    }}
                                >
                                    Sharpe Ratio: {sharpratio} ({rating})
                                </Typography> */}
                            </>
                        )}

                        {loaderForSymbolLink === true && (
                            <div>
                                <CircularProgress style={{position: "fixed", top: "40vh", left: "45vw"}} />
                            </div>
                        )}
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                    }}
                    className="maindiv"
                >
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            backgroundColor: "white",
                            paddingBottom: "2vw",
                            position: "relative",
                            height: "220px",
                            overflowY: "auto",
                        }}
                    >
                        {initialPage && (
                            <Box
                                component="main"
                                sx={{
                                    flexGrow: 1,
                                    p: 3,
                                    overflowY: "auto",
                                }}
                            >
                                <div style={{borderRadius: "10px", background: "white", padding: "10px"}}>
                                    <div>
                                        <h3>Portfolio</h3>
                                    </div>
                                    <div className="frameParent8">
                                        <div className="frameParent9" style={{padding: "10px"}}>
                                            <img
                                                className="frameIcon6"
                                                alt=""
                                                src={window.constants.asset_path + "/images/frame20.svg"}
                                            />
                                            <div className="youDontHaveContainer">
                                                {nodatafoundmsgtype === "zeroholding" ? (
                                                    <strong>
                                                        <h3
                                                            className="youDontHave"
                                                            style={{fontWeight: "400", color: "black"}}
                                                        >
                                                            You have 0 Holdings at the Moment
                                                        </h3>
                                                        {/* <h3 style={{ fontWeight: "400", color: "black" }}>0 Holdings at the Moment </h3> */}
                                                    </strong>
                                                ) : (
                                                    <strong>
                                                        <h3
                                                            className="youDontHave"
                                                            style={{fontWeight: "400", color: "black"}}
                                                        >
                                                            Create New
                                                        </h3>
                                                        <h3 style={{fontWeight: "400", color: "black"}}>Portfolio</h3>
                                                    </strong>
                                                )}
                                                <button
                                                    style={{
                                                        backgroundColor: "#4460EF",
                                                        width: "200px",
                                                        height: "50px",
                                                        borderRadius: "5px",
                                                        marginTop: "20px",
                                                        border: "2px solid #4460EF",
                                                        color: "white",
                                                    }}
                                                    onClick={handleCreateNew}
                                                >
                                                    Add Cryptos to this Portfolio
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Box>
                        )}
                        {!initialPage && (
                            <>
                                {loader === false && (
                                    <>
                                        <div
                                            style={{
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                borderRadius: "8px",
                                                textAlign: "center",
                                                zIndex: 999,
                                                position: "absolute",
                                                backdropFilter: "none", // Optional: to add some spacing inside the div
                                            }}
                                        >
                                            <style>{leftRightMotion}</style>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    width: "35px",
                                                    height: "35px",
                                                }}
                                            >
                                                <img
                                                    src={window.constants.asset_path + "/images/lens.png"}
                                                    alt="Searching Lens"
                                                    style={{
                                                        width: "35px",
                                                        height: "35px",
                                                        position: "absolute",
                                                        animation: `leftRightMotion 1.5s infinite ease-in-out`,
                                                    }}
                                                />
                                            </div>
                                            <p style={{marginTop: "10px", fontSize: "18px", color: "black"}}>
                                                <b>Analyzing Your Portfolio</b>
                                            </p>
                                        </div>
                                    </>
                                )}
                                {loader && (
                                    <Table
                                        className="non_responsiveTable"
                                        aria-label="customized table"
                                        style={{
                                            borderCollapse: "separate",
                                            borderSpacing: "1px 0", // ⬅️ horizontal: 10px, vertical: 0
                                            width: "99%",
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell
                                                    className="cryptotableviewHeader"
                                                    style={{padding: 0, width: "12%", whiteSpace: "nowrap"}}
                                                >
                                                    <div disabled style={cellStyle}>
                                                        <p style={{margin: 0}}>Last 1 Day</p>
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className="cryptotableviewHeader"
                                                    style={{padding: 0, width: "12%", whiteSpace: "nowrap"}}
                                                >
                                                    <div disabled style={cellStyle}>
                                                        <p style={{margin: 0}}>Last 7 Days</p>
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className="cryptotableviewHeader"
                                                    style={{padding: 0, width: "12%", whiteSpace: "nowrap"}}
                                                >
                                                    <div disabled style={cellStyle}>
                                                        <p style={{margin: 0}}>Last 30 Days</p>
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className="cryptotableviewHeader"
                                                    style={{padding: 0, width: "12%", whiteSpace: "nowrap"}}
                                                >
                                                    <div disabled style={cellStyle}>
                                                        <p style={{margin: 0}}>Last 90 Days</p>
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className="cryptotableviewHeader"
                                                    style={{padding: 0, width: "12%", whiteSpace: "nowrap"}}
                                                >
                                                    <div disabled style={cellStyle}>
                                                        <p style={{margin: 0}}>Grade</p>
                                                    </div>
                                                </StyledTableCell>
                                            </TableRow>
                                            <StyledTableRow style={{backgroundColor: "white"}}>
                                                {[
                                                    portfolio_1day,
                                                    portfolio_7days,
                                                    portfolio_30days,
                                                    portfolio_90days,
                                                ].map((data, index) => (
                                                    <StyledTableCell
                                                        key={index}
                                                        style={{
                                                            verticalAlign: "middle",
                                                            textAlign: "center",
                                                            padding: "12px 0",
                                                            background:
                                                                "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                            borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                            borderBottom: "1px solid rgba(24, 119, 242, 1)",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize: "15px",
                                                                fontWeight: "500",
                                                                lineHeight: "24px",
                                                                color: "#000",
                                                            }}
                                                        >
                                                            {data}
                                                        </span>
                                                    </StyledTableCell>
                                                ))}

                                                <StyledTableCell
                                                    style={{
                                                        verticalAlign: "middle",
                                                        textAlign: "center",
                                                        padding: "12px 0",
                                                        background:
                                                            "linear-gradient(180deg, rgba(24, 119, 242, 0.4) -1.89%, rgba(24, 119, 242, 0) 60.38%)",
                                                        borderRight: "1px solid rgba(24, 119, 242, 1)",
                                                        borderBottom: "1px solid rgba(24, 119, 242, 1)",
                                                    }}
                                                >
                                                    {portfolio_grade ? (
                                                        <button
                                                            disabled
                                                            style={{
                                                                fontWeight: "bold",
                                                                padding: isSmallScreen ? "3px" : "5px",
                                                                borderRadius: "5px",
                                                                border: "1px solid",
                                                                width: "100%",
                                                                fontSize: isSmallScreen ? "9px" : "14px",
                                                                backgroundColor:
                                                                    portfolio_grade === "Outperformer" ||
                                                                    portfolio_grade === "Emerging Outperformer"
                                                                        ? "#DFFFF0"
                                                                        : portfolio_grade === "Moderate Performer"
                                                                        ? "#F9F4E7"
                                                                        : portfolio_grade === "Underperformer"
                                                                        ? "#FFE3E3"
                                                                        : "#fff", // default fallback
                                                                color:
                                                                    portfolio_grade === "Outperformer" ||
                                                                    portfolio_grade === "Emerging Outperformer"
                                                                        ? "#199F5F"
                                                                        : portfolio_grade === "Moderate Performer"
                                                                        ? "#D4AF37"
                                                                        : portfolio_grade === "Underperformer"
                                                                        ? "#FF4141"
                                                                        : "#000", // default fallback
                                                                borderColor:
                                                                    portfolio_grade === "Outperformer" ||
                                                                    portfolio_grade === "Emerging Outperformer"
                                                                        ? "#199F5F"
                                                                        : portfolio_grade === "Moderate Performer"
                                                                        ? "#D4AF37"
                                                                        : portfolio_grade === "Underperformer"
                                                                        ? "#FF4141"
                                                                        : "#ccc", // default fallback
                                                            }}
                                                        >
                                                            {portfolio_grade}
                                                            {/* Underperformer */}
                                                        </button>
                                                    ) : (
                                                        <span style={{fontSize: "15px"}}>NA</span>
                                                    )}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                    </Table>
                                )}
                            </>
                        )}
                    </Box>
                    {mediaQueryVar === false && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0",
                                backgroundColor: "white",
                                width: "105%",
                                zIndex: "100",
                                marginLeft: "-10px",
                            }}
                        >
                            <BottomNavigation showLabels>
                                <BottomNavigationAction
                                    label="Top Portfolios"
                                    onClick={() => navigate("/portfolio-gallery")}
                                    icon={
                                        <img
                                            src={
                                                loc === "/portfolio-gallery"
                                                    ? "/images/dashboardS.svg"
                                                    : "/images/dashboardU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="My Portfolios"
                                    onClick={() => {
                                        navigate(userData ? "/my-portfolio" : "/audit-my-portfolio");
                                    }}
                                    icon={
                                        <img
                                            src={
                                                loc === "/my-portfolio"
                                                    ? "/images/portfolioS.svg"
                                                    : "/images/portfolioU.svg"
                                            }
                                        />
                                    }
                                />
                                <BottomNavigationAction
                                    label="$1/Month Subscription"
                                    onClick={() => {
                                        if (userData) {
                                            navigate("/subscriptions/screener360");
                                        } else {
                                            const originalUrl = "/subscriptions/screener360";
                                            sessionStorage.setItem("originalUrl", originalUrl);
                                            handleLoginClick();
                                        }
                                    }}
                                    icon={
                                        <img
                                            src={
                                                loc === "/subscriptions/screener360"
                                                    ? "/images/dollarS.svg"
                                                    : "/images/dollarU.svg"
                                            }
                                            width={24}
                                            height={24}
                                            alt="Icon"
                                            style={{marginBottom: "-3px"}}
                                        />
                                    }
                                />
                            </BottomNavigation>
                        </div>
                    )}
                </Box>
            )}
            {goToSubscribeAlertOpen && (
                <GoToSubscribeAlert onClose={setGoToSubscribeAlertOpen} text={subscriptionText} />
            )}
        </>
    );
}

export default PerformanceTable;
